module.exports = __webpack_public_path__ + "static/img/fish13.6f261a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish13.png
// module id = uYoK
// module chunks = 0